// extracted by mini-css-extract-plugin
module.exports = {"card":"e5Iyk"};